/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * A storage service wrapper whose sole job is to intercept calls to uploadSummaryWithContext and ensure they include
 * the protocol summary, using the provided callback to add it if necessary.
 */
export class ProtocolTreeStorageService {
    /**
     *
     * @param internalStorageService - Document storage service responsible to make api calls to the storage.
     * @param addProtocolSummaryIfMissing - Function to add protocol summary tree to the summary. Used in scenarios where single-commit summaries are used.
     * @param shouldSummarizeProtocolTree - Callback function to learn about the service preference on whether single-commit summaries are enabled.
     */
    constructor(internalStorageService, addProtocolSummaryIfMissing, shouldSummarizeProtocolTree) {
        this.internalStorageService = internalStorageService;
        this.addProtocolSummaryIfMissing = addProtocolSummaryIfMissing;
        this.shouldSummarizeProtocolTree = shouldSummarizeProtocolTree;
        this.getSnapshotTree = internalStorageService.getSnapshotTree.bind(internalStorageService);
        this.getSnapshot = internalStorageService.getSnapshot?.bind(internalStorageService);
        this.getVersions = internalStorageService.getVersions.bind(internalStorageService);
        this.createBlob = internalStorageService.createBlob.bind(internalStorageService);
        this.readBlob = internalStorageService.readBlob.bind(internalStorageService);
        this.downloadSummary = internalStorageService.downloadSummary.bind(internalStorageService);
        this.dispose = internalStorageService.dispose.bind(internalStorageService);
    }
    get policies() {
        return this.internalStorageService.policies;
    }
    get disposed() {
        return this.internalStorageService.disposed;
    }
    async uploadSummaryWithContext(summary, context) {
        return this.shouldSummarizeProtocolTree()
            ? this.internalStorageService.uploadSummaryWithContext(this.addProtocolSummaryIfMissing(summary), context)
            : this.internalStorageService.uploadSummaryWithContext(summary, context);
    }
}
//# sourceMappingURL=protocolTreeDocumentStorageService.js.map